import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * This utility function provides a way to handle class names in Vue components,
 * solving common challenges with dynamic and conditional class application.
 *
 * - Combines multiple class inputs (strings, arrays, conditionals)
 * - Resolves conflicts between Tailwind classes
 * - Supports conditional class application
 * - Removes duplicate and conflicting classes
 *
 * // Basic usage with multiple classes
 * cn("base-class", "additional-class")
 *
 * // Conditional class application
 * cn(
 *   "always-present-class",
 *   props.active && "active-class",
 *   props.disabled && "disabled-class"
 * )
 *
 * cn(
 *   "p-4",
 *   props.class // allows overriding default classes
 * )
 *
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
